// ============================================
// 2026-10-15（P0-② 场景属性面板）：EnvironmentPanel 已并入 SceneSettingsPanel。
// 本文件保留为薄壳重定向，避免历史引用（PropertyTreePanel「环境」节点）断裂；P1 清理。
// ============================================
import SceneSettingsPanel from './SceneSettingsPanel';

export default function EnvironmentPanel() {
  return <SceneSettingsPanel />;
}
